// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__pffbf","container":"styles_container__QhIfF","close":"styles_close__IRmnn"};